module.exports = __webpack_public_path__ + "static/media/Muli-SemiBold.92860f9d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli/Muli-SemiBold.ttf
// module id = 1295
// module chunks = 1